module.exports = __webpack_public_path__ + "static/media/GuildGrown.8ceb3511.svg";